import { render, staticRenderFns } from "./ks-recruit-JD.vue?vue&type=template&id=37eca1b4"
var script = {}
import style0 from "./ks-recruit-JD.vue?vue&type=style&index=0&id=37eca1b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports